import { CnFormDialog } from '@/components/cn-form-dialog';

export default CnFormDialog;
